var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 17",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4094 8.28024L17.8394 0.850244C18.1594 0.540244 17.9294 0.000244141 17.4894 0.000244141H16.0794C15.9494 0.000244141 15.8194 0.0502441 15.7294 0.150244L9.00939 6.87024L2.26939 0.150244C2.17939 0.0602441 2.04939 0.000244141 1.91939 0.000244141H0.499395C0.0593946 0.000244141 -0.170605 0.540244 0.149395 0.850244L7.57939 8.28024L0.149395 15.7102C-0.170605 16.0302 0.0593946 16.5602 0.499395 16.5602H1.90939C2.03939 16.5602 2.16939 16.5102 2.25939 16.4102L8.97939 9.69024L15.6994 16.4102C15.7894 16.5002 15.9194 16.5602 16.0494 16.5602H17.4594C17.9094 16.5602 18.1294 16.0202 17.8094 15.7102L10.3794 8.28024H10.4094Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/IconClose.559bdb15d08943e82863fec42c6f6f05.svg";
export { ForwardRef as ReactComponent };